var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232.582 232.582",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 232.582 232.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11.326,107.724c0-2 0.489-4.047 1.466-5.495 0.977-1.449 2.319-2.149 4.026-2.149 1.909,0 3.341,0.573 4.296,1.695 0.954,1.124 1.432,2.635 1.432,4.522 0,1.325-0.472,2.889-1.415,4.685-0.943,1.797-2.598,3.842-4.598,6.133l-15.951,16.578v7.031h34v-8h-18.438l-.102-.392 6.638-7.203c4.313-4.694 7.271-8.28 8.878-10.661 1.605-2.381 2.408-5.145 2.408-8.244 0-4.604-1.511-8.243-4.531-10.895-3.021-2.649-7.227-3.98-12.617-3.98-5.076,0-9.153,1.575-12.23,4.73-3.077,3.155-4.56,6.953-4.447,11.49l.068,.154h11.117z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.582,57.724 0.582,57.724 0.582,66.724 34.582,66.724 34.582,57.724 23.582,57.724 23.582,17.136 0.582,20.572    0.582,28.724 11.582,28.724  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.026,189.594c2.313-1.056 4.161-2.521 5.542-4.396 1.382-1.875 2.072-3.926 2.072-6.148 0-4.47-1.595-7.923-4.784-10.36-3.189-2.438-7.445-3.655-12.769-3.655-4.582,0-8.479,1.213-11.691,3.639-3.212,2.426-4.751,5.767-4.616,9.675l.068,.377h11.051c0-2 0.56-2.623 1.684-3.477 1.123-0.854 2.426-1.367 3.908-1.367 1.887,0 3.324,0.484 4.313,1.54 0.988,1.056 1.482,2.336 1.482,3.886 0,1.954-0.55,3.574-1.65,4.675-1.101,1.101-2.673,1.743-4.717,1.743h-5.337v8h5.337c2.269,0 4.026,0.67 5.273,1.759 1.247,1.09 1.87,2.888 1.87,5.268 0,1.708-0.596,3.154-1.785,4.277-1.191,1.123-2.786,1.699-4.785,1.699-1.752,0-3.239-0.755-4.464-1.821-1.225-1.066-1.836-2.182-1.836-4.182h-11.119l-.067,.432c-0.112,4.582 1.555,8.196 5.003,10.61 3.448,2.414 7.474,3.679 12.078,3.679 5.346,0 9.737-1.256 13.174-3.828 3.437-2.571 5.154-6.09 5.154-10.582 0-2.74-0.74-5.085-2.223-7.051-1.483-1.967-3.538-3.426-6.166-4.392z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 181,
    x: 51.582,
    y: 164.724,
    height: 33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 181,
    x: 51.582,
    y: 99.724,
    height: 33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 181,
    x: 51.582,
    y: 32.724,
    height: 33
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.1dbb295dd53744dbc4fb85d493830a85.svg";
export { ForwardRef as ReactComponent };